export const iconArr = [
  'https://file.tanscrm.com/crm/config/icon/bm-web-1.png',
  'https://file.tanscrm.com/crm/config/icon/bm-web-2.png',
  'https://file.tanscrm.com/crm/config/icon/bm-web-3.png',
  'https://file.tanscrm.com/crm/config/icon/bm-web-4.png',
  'https://file.tanscrm.com/crm/config/icon/bm-web-5.png',
  'https://file.tanscrm.com/crm/config/icon/bm-web-6.png',
  'https://file.tanscrm.com/crm/config/icon/bm-web-7.png',
  'https://file.tanscrm.com/crm/config/icon/bm-web-8.png',
  'https://file.tanscrm.com/crm/config/icon/bm-web-9.png',
  'https://file.tanscrm.com/crm/config/icon/bm-web-10.png',
  'https://file.tanscrm.com/crm/config/icon/bm-web-11.png',
  'https://file.tanscrm.com/crm/config/icon/bm-web-12.png',
]
// showType(tenantType): 租户类型 1:企业 2:组织 3:专家
export const moduleList = [
  {
    moduleName: "企业名称",
    moduleIcon: require('../../../../../assets/website/company-name.png'),
    moduleCode: 17,
    showType: '1,2,3',
    icon: "el-icon-tickets"
  },
  {
    moduleName: "关于我们",
    moduleIcon: require('../../../../../assets/website/about-icon.png'),
    moduleCode: 1,
    showType: '1,2,3',
    icon: "el-icon-tickets"
  },
  {
    moduleIcon: require('../../../../../assets/website/article-icon.png'),
    moduleName: "企业文章",
    moduleCode: 3,
    showType: '1,2,3',
    icon: "el-icon-tickets"
  },
  {
    moduleName: "管理团队",
    moduleIcon: require('../../../../../assets/website/team-icon.png'),
    moduleCode: 7,
    showType: '1,2,3',
    icon: "el-icon-user"
  },
  {
    moduleName: "合作伙伴",
    moduleIcon: require('../../../../../assets/website/coopera-icon.png'),
    moduleCode: 6,
    showType: '1,2,3',
    icon: "el-icon-tickets"
  },
  {
    moduleIcon: require('../../../../../assets/website/contact-icon.png'),
    moduleName: "联系我们",
    moduleCode: 5,
    showType: '1,2,3',
    icon: "el-icon-tickets"
  },
  {
    moduleName: "案例",
    moduleIcon: require('../../../../../assets/website/case-icon.png'),
    moduleCode: 4,
    showType: '1,2,3',
    icon: "el-icon-tickets"
  },
  // {
  //   moduleName: "企业VR介绍",
  //   icon: "el-icon-tickets"
  // },
  {
    moduleName: "产品",
    moduleIcon: require('../../../../../assets/website/product-icon.png'),
    moduleCode: 2,
    showType: '1,2,3',
    icon: "el-icon-tickets"
  },{
    moduleName: "入驻组织",
    moduleIcon: require('../../../../../assets/website/join-group.png'),
    moduleCode: 9,
    showType: '1',
    icon: "el-icon-tickets"
  },
  // {
  //   moduleName: "分类",
  //   moduleIcon: require('../../../../../assets/website/product-icon.png'),
  //   moduleCode: 10,
  //   showType: '1,3',
  //   icon: "el-icon-tickets"
  // },
  {
    moduleName: "组织成员",
    moduleIcon: require('../../../../../assets/website/group-member.png'),
    moduleCode: 13,
    showType: '2',
    icon: "el-icon-tickets"
  },
  {
    moduleName: "图片",
    moduleIcon: require('../../../../../assets/website/img-icon.png'),
    moduleCode: 11,
    showType: '1,2,3',
    icon: "el-icon-tickets"
  },{
    moduleName: "视频",
    moduleIcon: require('../../../../../assets/website/video-icon2.png'),
    moduleCode: 12,
    showType: '1,2,3',
    icon: "el-icon-tickets"
  },
  {
    moduleName: "知识产权",
    moduleIcon: require('../../../../../assets/website/knowledge-icon.png'),
    moduleCode: 14,
    showType: '1,2,3',
    icon: "el-icon-tickets"
  },
  {
    moduleName: "技术文章",
    moduleIcon: require('../../../../../assets/website/tech-article.png'),
    moduleCode: 15,
    showType: '1,2,3',
    icon: "el-icon-tickets"
  },
  {
    moduleName: "招标信息",
    moduleIcon: require('../../../../../assets/website/bidding-icon.png'),
    moduleCode: 16,
    showType: '1,2,3',
    icon: "el-icon-tickets"
  },
]
export const baseList = [
  {
    moduleName: "标题",
    moduleCode: 100,
    moduleIcon: require('../../../../../assets/website/title-icon.png'),
    icon: "el-icon-tickets"
  },
  // {
  //   moduleName: "文本",
  //   moduleCode: 101,
  //   icon: "el-icon-tickets"
  // },
  {
    moduleName: "", // 单图片
    moduleIcon: require('../../../../../assets/website/img-icon.png'),
    moduleCode: 102,
    icon: "el-icon-user"
  },
  {
    moduleName: "轮播图",
    moduleIcon: require('../../../../../assets/website/carousel-icon.png'),
    moduleCode: 103,
    icon: "el-icon-tickets"
  },
  {
    moduleName: "", // 单视频
    moduleIcon: require('../../../../../assets/website/video-icon2.png'),
    moduleCode: 104,
    icon: "el-icon-tickets"
  },
  // {
  //   moduleName: "咨询",
  //   moduleCode: "service",
  //   icon: "el-icon-tickets"
  // }
]

export const appInfos = [
  {
    moduleName: "轮播图",
    moduleCode: 103,
    content: [
      {
        targetType: 1, // 不需要跳转可以不传，目标类型 1-文章 2-产品 3-案例
        targetId: 0, // 跳转目标id
        picUrl: "",
        jumpFlag: 0, // 是或支持跳转 0-不支持 1-支持
        fileObjs: []
      }
    ],
    showShadow: true,
  },
  {
    moduleName: "关于我们",
    moduleCode: 1,
    moduleIcon: iconArr[0],
    content: {
      fileObjs: [],
      picUrl:'',
      introduction: '关于我们'
    },
    title: "关于我们",
    showShadow: true
  },
  {
    moduleIcon: iconArr[0],
    moduleName: "企业文章",
    moduleCode: 3,
    title: "热门文章",
    content: [], // 文章列表
    showShadow: true
  },
  {
    moduleName: "产品",
    moduleCode: 2,
    moduleIcon: iconArr[0],
    title: "推荐产品",
    content: [], // 文章列表
    showShadow: true
  },
  {
    moduleName: "案例",
    moduleCode: 4,
    moduleIcon: iconArr[0],
    title: "经典案例",
    content: [], // 文章列表
    showShadow: true
  },
  {
    moduleName: "联系我们",
    moduleCode: 5,
    moduleIcon: iconArr[0],
    title: "联系我们",
    content: {
      linkPhoneNumber: '',
      linkAddress: ''
    },
    showShadow: true
  }
]
